// @flow
import * as React from 'react';
import styled from 'styled-components';
import {LayoutWrapper} from 'components/Layout';
import {LocalText} from 'components/Localized';
import { BackgroundImage } from 'components/Image';
import { IsDesktopAgent, IsMobileAgent } from 'components/Responsive';
import * as VRUtils from 'utils/vrUtils';

type Props = {
  onComplete: () => void,
  closing: boolean,
  closingDuration: number,
};

export default function Loading(props: Props): React.Element<any> {
  const [loadingRate, setLoadingRate] = React.useState(0);
  const loadingRef = React.useRef(0);
  //const timer = React.useRef(null);

  function updateLoadingRate(rate: number) {
    setLoadingRate(rate);
  }

  // const advanceLoadingRateFake = React.useCallback(() => {
  //   loadingRef.current += 0.1;
  //   updateLoadingRate(loadingRef.current);
  //   //console.log(loadingRef.current);
  //   if (loadingRef.current >= 100) {
  //     loadingRef.current -= 100;
  //     return;
  //     if (timer.current) {
  //       clearInterval(timer.current);
  //       timer.current = null;
  //       //props.onComplete();
  //     }
  //   }
  // }, [props]);

  const advanceLoadingRate = React.useCallback((rate : number) => {
    loadingRef.current = rate;
    updateLoadingRate(loadingRef.current);
    //console.log(loadingRef.current);
    if (loadingRef.current >= 100) {
      props.onComplete();
    }
  }, [props]);

  React.useEffect(() => {
    VRUtils.addVREventListener("loadingRate", advanceLoadingRate);
    //timer.current = setInterval(advanceLoadingRateFake, 10);
    return () => {
      VRUtils.removeVREventListener("loadingRate", advanceLoadingRate);
      // if (timer.current) {
      //   clearInterval(timer.current);
      //   timer.current = null;
      // }
    };
  }, [advanceLoadingRate]);

  return (
    <LoadingPage dataClosing={props.closing} closingDuration={props.closingDuration}>
      <div>
        <LoadingTitle />
      </div>
      <CenterBar closingDuration={props.closingDuration}>
        <IsMobileAgent>
          <LoadingContents loadingRate={loadingRate} />
        </IsMobileAgent>
        <IsDesktopAgent>
          <MainModel source="./loading_main_model.png" />
        </IsDesktopAgent>
      </CenterBar>
      <div>
        <IsDesktopAgent>
          <LoadingContents loadingRate={loadingRate} />
          <Space dataHeight={30} />
        </IsDesktopAgent>
        <LocalText textKey="vehicles_warn_message" />
      </div>
    </LoadingPage>
  );
}

type PropsLogo = {
  loadingRate: number
}

function LoadingContents(props: PropsLogo): React.Element<any> {
  return <LoadingBarFrame>
    <LoadingBar dataLoading={props.loadingRate * 0.01} />
  </LoadingBarFrame>;
}

function LoadingTitle(): React.Element<any> {
  return <TitleWrapper>
    <LocalText textKey="loading_title_01" />
    <Space dataHeight={4} />
    <LocalText textKey="loading_title_02" />
  </TitleWrapper>;
}

const LoadingPage = styled(LayoutWrapper)`
  background-color: rgba(0, 0, 0, ${(props: any) => props.dataClosing ? 0 : 1});
  pointer-events: 'auto';

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 5000;

  transition: background-color ${(props: any) => props.closingDuration}s;

  > :first-child {
    flex: 1;

    display: flex;
    flex-direction: column;
    justify-content: ${(props: any) => props.theme.layout.sizeL ? 'flex-start' : 'flex-end'};
    align-items: center;

    margin-top: ${(props: any) => props.theme.layout.sizeL ? '70px' : undefined};
    margin-bottom: ${(props: any) => props.theme.layout.sizeL ? undefined : '40px'};
  }

  > :last-child {
    flex: 1;

    display: flex;
    flex-direction: column;
    justify-content: ${(props: any) => props.theme.layout.sizeL ? 'flex-end' : 'flex-end'};
    align-items: ${(props: any) => props.theme.layout.sizeL ? 'center' : 'flex-end'};
    text-align: center;

    margin-bottom: ${(props: any) => props.theme.layout.sizeL ? '40px' : '40px'};
  }
`;

const CenterBar = styled.div`
  display: flex;
  align-items: center;

  transition: height ${(props: any) => props.closingDuration}s;
`;

const LoadingBarFrame = styled.div`
  width: ${(props: any) => props.theme.layout.sizeL ? 320 : 280}px;
  height: ${(props: any) => props.theme.layout.sizeL ? 12 : 12}px;
  padding: 3px 3px;
  box-sizing: border-box;

  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;

  > div {
    height: 100%;
    border-radius: ${(props: any) => props.theme.layout.sizeL ? 8 : 8}px;
    background-color: #ffffff;
  }
`

const LoadingBar = styled.div`
  width: ${(props: any) => props.dataLoading * 100}%;
`

const MainModel = styled(BackgroundImage)`
  width: ${(props: any) => props.theme.layout.width * 0.6}px;
  height: ${(props: any) => props.theme.layout.width * 0.6 * 0.46}px;

  background-size: contain;
  background-repeat: no-repeat;

  margin-top: 143px;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Space = styled.div`
  height: ${(props: any) => props.dataHeight ? `${props.dataHeight}px` : undefined};
`